import React from "react";

export const Divider = () => (
  <div className={`h-[1px] bg-[#C6CCE8] w-full my-[32px]`}></div>
);
